import { DataSource } from "./DataSource";
import { getDomainDataURL } from "../infrastructure"
import { DomainModelsData } from "../composition/composition";
import { RulesetData } from "@domain/rules/Ruleset";

export default class DataSourceAPIImplementation implements DataSource {
    private async getFile(name: string, path: string = "byFamily") {
        let pathName = `/${path}/${name}.json`;
        let url = getDomainDataURL(pathName)

        if ((process.env.REACT_APP_ACTIVATE_ROUTE_CDN ?? false) && process.env.REACT_APP_ACTIVATE_ROUTE_CDN === '1') {
            url = process.env.REACT_APP_ROUTE_CDN_FILES + pathName
        }

        const response = await fetch(url)
        return response.json()
    }

    async getSubfamilyDataByName(familyName: string, catalog: string | number): Promise<DomainModelsData> {
        const indexFile = await this.getFile(familyName + '_' + catalog)
        return indexFile
    }

    async getSubfamilyDataByModel(model: string, catalog: string | number, isComplement: boolean = false): Promise<DomainModelsData> {
        const indexFile = await this.getFile('modelSubFamilyNameDictionary')
        const subfamilyName = indexFile[model]

        if (!subfamilyName) return null
        let filename = subfamilyName + '_' + catalog
        if (isComplement) {
            filename = 'accessories/' + filename
        }
        return this.getFile(filename)
    }

    private async getSubfamilyDataPathById(subfamilyId: string | number, catalog: string | number): Promise<string> {
        const subfamilyName = await this.getSubfamilyNameById(subfamilyId)

        if (!subfamilyName) return null
        const filename = subfamilyName + '_' + catalog

        return filename
    }

    private async getSubfamilyNameById(subfamilyId: string | number): Promise<string> {
        const indexFamily = await this.getFile('IndexSubfamiliesNames')
        const subfamilyName = indexFamily[subfamilyId]

        if (!subfamilyName) return null

        return subfamilyName
    }

    async getSubfamilyDataById(subfamilyId: string | number, catalog: string | number): Promise<DomainModelsData> {
        const filename = await this.getSubfamilyDataPathById(subfamilyId, catalog)

        return this.getFile(filename)
    }

    async getSubfamilyAccesoriesDataById(subfamilyId: string | number, catalog: string | number): Promise<DomainModelsData> {
        const filename = await this.getSubfamilyDataPathById(subfamilyId, catalog)
        const filepath = 'accessories/' + filename

        try {
            const result = await this.getFile(filepath)
            return result
        } catch (e) {
            console.error(e)
            return {}
        }
    }

    async getDataRulesBySubfamilyName(subfamilyId: string | number): Promise<RulesetData> {
        const filename = await this.getSubfamilyNameById(subfamilyId)
        try {
            const result = await this.getFile(filename, 'rules')
            return result
        } catch (e) {
            console.warn(e, `Imposible to get rules for subfamily ${subfamilyId}- returning empty ruleset`)
            return { rules: [] }
        }
    }

    async getInformationBySubFamilyIdWithAccessories(subfamilyId: number | string, catalog: number | string = '16'): Promise<DomainModelsData> {
        const subfamilyLuminariesData = await this.getSubfamilyDataById(subfamilyId, catalog)
        const subfamilyAccessoriesData = await this.getSubfamilyAccesoriesDataById(subfamilyId, catalog)
        const subfamilyData = { ...subfamilyLuminariesData, ...subfamilyAccessoriesData }
        return subfamilyData
    }

    async getSubfamilyDataByModelWithAccessories(model: string, catalog: string | number): Promise<DomainModelsData> {
        const indexFile = await this.getFile('modelSubFamilyNameDictionary')
        const subfamilyName = indexFile[model]

        if (!subfamilyName) return null
        let filename = subfamilyName + '_' + catalog
        const [subfamily, accesory] = await Promise.all([
            this.getFile(filename),
            this.getFile('accessories/' + filename),
        ])
        return { ...subfamily, ...accesory }
    }


    getSubfamilies(): Promise<any> {
        return this.getFile("Subfamilies")
    }
}